import { createSlice } from '@reduxjs/toolkit';
import { FIELD_CLASS } from '../../utils/constants';
import { USER } from '../types';

const authSlice = createSlice({
    name: USER,
    initialState: {
        data: {},
        updateOptions: {
            firstName: { name: 'firstName', type: 'text', label: 'First Name', className: FIELD_CLASS },
            lastName: { name: 'lastName', type: 'text', label: 'Last Name', className: FIELD_CLASS },
            newPassword: {
                name: 'newPassword',
                type: 'password-field',
                label: 'New Password',
                className: FIELD_CLASS
            },
            confirmPassword: {
                name: 'confirmPassword',
                type: 'password-field',
                label: 'Confirm Password',
                className: FIELD_CLASS
            }
        },
        formData: false,
        notificationsData: { count: 0, data: [], open: true },
        verifyUsername: ''
    },
    reducers: {
        loginRequest() {},
        logoutRequest() {},
        registerRequest() {},
        verifyRequest() {},
        forgotPasswordRequest() {},
        resetPasswordRequest() {},
        getUserRequest() {},
        getUserSuccess(state, action) {
            state.data = action.payload;
        },
        updateUserRequest() {},
        setSettingsFormData(state, action) {
            state.formData = action.payload;
        },
        setUpdateModalOptions(state, action) {
            state.updateOptions = action.payload;
        },
        setNotificationData(state, action) {
            Object.entries(action.payload).forEach((obj) => {
                state.notificationsData[obj[0]] = obj[1];
            });
        },
        setVerifyUserName(state, action) {
            state.verifyUsername = action.payload;
        },
        getNotificationRequest() {},
        updateNotificationRequest() {}
        // subscribeNotificationRequest() {}
    }
});

export const {
    loginRequest,
    logoutRequest,
    registerRequest,
    verifyRequest,
    forgotPasswordRequest,
    resetPasswordRequest,
    getUserRequest,
    getUserSuccess,
    updateUserRequest,
    setSettingsFormData,
    setUpdateModalOptions,
    setNotificationData,
    getNotificationRequest,
    updateNotificationRequest,
    setVerifyUserName
    // subscribeNotificationRequest
} = authSlice.actions;

export const authReducer = authSlice.reducer;
